import React, { useEffect, useState } from 'react';

import { Utils } from '@adobe/aem-react-editable-components';
import { MapTo } from '@adobe/aem-spa-component-mapping';
import { useAuth } from 'context/Auth';
import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';

import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { MyDataTestingBanner } from 'components/FormHelper/FormTestingBanners/MyDataTestingBanner';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { getInstallerStatusbarData } from 'utils/InstallerUtils';
import { withTenant } from 'utils/tenantUtil';

import { FachinteressentStatusbarContent } from './FachinteressentStatusbarContent';
import { InstallerStatusbarContent } from './InstallerStatusbarContent';

import './InstallerStatusbar.sass';

export const InstallerStatusbar = () => {
  const { installer, isLoading } = useCurrentInstaller();
  const { isCIAM } = useAuth();
  const [installerData, setInstallerData] = useState({});

  useEffect(() => {
    if (!installer) return;
    const installerDataResponse = getInstallerStatusbarData(installer);
    setInstallerData(installerDataResponse);
  }, [installer]);

  const isEditor = Utils.isInEditor();

  const { id, name, gasEntry, energyEntry, limitationEntry, isFachinteressent } = installerData;

  const getTitle = () => {
    if (isEditor) {
      return 'Test Installer';
    }
    if (isLoading) return '';
    if (isCIAM === false)
      return 'Statusanzeige Installateur - Sie sind nicht im Installateurverzeichnis als Installateur hinterlegt';

    return name || '';
  };

  if (isEditor) {
    return <RenderAemComponent componentProps={{}} name="InstallerStatusBar" />;
  }
  return (
    <div
      className="installer-statusbar installer-statusbar__outer-container"
      data-testid={withTenant('installerStatusbar')}>
      <div className="installer-statusbar__content-container">
        <MyDataTestingBanner />
        <div>
          <SubTitle text={getTitle()} notFramed />
        </div>
        <div>
          {isLoading ? (
            <LoadingIndicator />
          ) : isFachinteressent ? (
            <FachinteressentStatusbarContent
              id={id}
              energyEntry={energyEntry}
              gasEntry={gasEntry}
            />
          ) : (
            <InstallerStatusbarContent
              id={id}
              energyEntry={energyEntry}
              gasEntry={gasEntry}
              limitationEntry={limitationEntry}
            />
          )}
        </div>
      </div>
    </div>
  );
};

MapTo(['e-fix/components/content/installerstatusbar'])(InstallerStatusbar);

InstallerStatusbar.displayName = 'InstallerStatusbar';

InstallerStatusbar.propTypes = {};

InstallerStatusbar.defaultProps = {};
